import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';

// baseURL
var baseURL = "https://api.agendaenlinea.cl/api/";
var urlGlobal = '';
import { env } from '../config/env.js';
if (!process.env.NODE_ENV) process.env.NODE_ENV = JSON.parse(config.dev.env.NODE_ENV)
/*
if (process.env.NODE_ENV == 'development') {
  baseURL = env.baseURL;
  urlGlobal = env.urlGlobal
}
*/

/** AGREGADO POR MAURICIO MARCHANT PARA ESTABLECER 3 AMBIENTES, LOCAL-DESARROLLO Y PRODUCCIÓN INDEPENDIENTE SI LA APP ESTÁ EN MODO PRODUCTION O DELVELOPMENT*/

switch(env.enviroment){
    default: 
        baseURL = env.baseURL;
        urlGlobal = env.urlGlobal;
    break;
    case 'local':
        baseURL = env.LOCALbaseURL;
        urlGlobal = env.LOCALurlGlobal;
    break;
    case 'development':
        baseURL = env.DEVbaseURL;
        urlGlobal = env.DEVurlGlobal;
    break;
}

// instance axios
var instance_axios = axios.create({
    baseURL: baseURL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});
Vue.use(VueAxios, instance_axios);

// loadData by default
export const loadData = ({ commit }) => {
    let url = 'doctor/auth/login';
    let parent = localStorage.getItem('parent_amol');
    if (parent) {
        url += '?parent=' + parent;
    }
    Vue.axios.post(url, {}, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token_amol'),
            }
        })
        .then(response => {
            let data = response.data.data;
            if (!data.user.avatar || data.user.avatar.length < 5) {
                data.user.avatar = "https://api.agendaenlinea.cl/image/default_avatar.png";
            }
            if (data) {
                data.user.parent = localStorage.getItem('parent_amol');
                commit('SET_USER', data.user);
            }
        });
};

import { doctor } from '../config/api.js';

// loadLanguage by default
export const loadLanguage = ({ commit }) => {
    let lang_amol = localStorage.getItem('lang_amol');
    if (lang_amol) {
        set_language(lang_amol, data => {
            commit('SET_APP', data.app);
            commit('SET_LANG', lang_amol);
            commit('SET_LANGUAGES', data.languages);
        });
    } else {
        var language = window.navigator.userLanguage || window.navigator.language;
        var lang_navigator = language.split('-')[0];
        var lang_navigator = 'es';
        localStorage.setItem('lang_amol', lang_navigator);
        set_language(lang_navigator, data => {
            commit('SET_APP', data.app);
            commit('SET_LANG', lang_navigator);
            commit('SET_LANGUAGES', data.languages);
        });
    }
};

// setLanguage
var set_language = function(lang, callback) {
    let url_set = doctor.api.lang.set + '/' + lang;
    let url_app = doctor.api.lang.trans+"?prefix="+window.countryCODE;
    let url_enabled = doctor.api.lang.enabled;
    let data = {};
    Vue.axios.get(url_set)
        .then(response => {
            Vue.axios.get(url_app)
                .then(response => {
                    data.app = response.data.data;
                    Vue.axios.get(url_enabled)
                        .then(response_enabled => {
                            data.languages = response_enabled.data.data;
                            callback(data);
                        });
                });
        });
}



// WEBPACK FOOTER //
// ./src/store/actions.js